import { adminRoutes } from '@/routers/routes';

export const isGuarded = (path: string): boolean => {
  return adminRoutes.find((route) => route.path === path)?.isGuarded === true;
};
